import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/utils/classNames.ts';

const WAYPOINTS = [
  { cx: 8, cy: 34 },
  { cx: 112, cy: 12 },
  { cx: 208, cy: 34 },
  { cx: 312, cy: 14 },
];

const ROUTE = 'M 8 34 C 60 34, 68 12, 112 12 S 176 34, 208 34 S 268 14, 312 14';

type CodyWorkingProps = {
  ask?: string | null;
  className?: string;
};

const CodyWorking: FC<CodyWorkingProps> = ({ ask, className }) => {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={cn('absolute inset-0 z-30 cursor-wait bg-journi-theme-light/85 backdrop-blur-[2px]', className)}
    >
      <div className="sticky top-1/2 flex -translate-y-1/2 flex-col items-center gap-5 px-6 text-center">
        <p className="font-sans text-xs font-semibold uppercase tracking-[0.2em] text-primary">
          {t('tripPage.working.eyebrow')}
        </p>

        {ask ? (
          <p className="max-w-xl font-feature text-3xl font-medium italic leading-tight text-[#2F2D2A] md:text-4xl">
            {t('tripPage.working.ask', { ask })}
          </p>
        ) : null}

        <RouteLine />

        <p className="max-w-sm font-sans text-sm text-text-secondary">{t('tripPage.working.caption')}</p>
      </div>
    </div>
  );
};

const RouteLine: FC = () => (
  <svg
    aria-hidden="true"
    viewBox="0 0 320 48"
    className="h-12 w-full max-w-[320px] text-primary"
    fill="none"
    stroke="currentColor"
  >
    <path d={ROUTE} strokeWidth={2} strokeLinecap="round" className="opacity-20" />
    <path
      d={ROUTE}
      strokeWidth={2}
      strokeLinecap="round"
      strokeDasharray="10 12"
      className="animate-route-flow motion-reduce:animate-none motion-reduce:opacity-0"
    />
    {WAYPOINTS.map((waypoint, index) => (
      <circle
        key={`${waypoint.cx}-${waypoint.cy}`}
        cx={waypoint.cx}
        cy={waypoint.cy}
        r={3.5}
        fill="currentColor"
        stroke="none"
        style={{ animationDelay: `${index * 0.3}s` }}
        className="animate-waypoint [transform-box:fill-box] [transform-origin:center] motion-reduce:animate-none"
      />
    ))}
  </svg>
);

export default CodyWorking;
